const { isEmpty } = require("./miscellaneous");
const { showBrowserNotification } = require("./ui_interactions");
const { parseChatMessage } = require("./chat_features");
const {
    insereOportunidadeKanban,
    enviaOportunidadeParaOReact,
    atualizaCardOportunidadeKanbanNaFase,
    atualizaHtmlCardOportunidadeKanban,
} = require("./ajax_requests");

/**
 * Só reordena o card no topo da coluna (kanban / minhas oportunidades), sem alterar badge.
 */
export function isCarteiraKanbanPage() {
    return document.querySelector(".page-carteira-kanban") !== null;
}

export function novaMensagemUpdateCarteiraKanban(oportunidadeId) {
    if (!isCarteiraKanbanPage()) {
        return;
    }
    window.dispatchEvent(
        new CustomEvent("eloca:carteira-kanban-nova-mensagem", {
            detail: { oportunidadeId: Number(oportunidadeId) },
        }),
    );
}

export function leituraOportunidadeUpdateCarteiraKanban(oportunidadeId) {
    if (!isCarteiraKanbanPage()) {
        return;
    }
    window.dispatchEvent(
        new CustomEvent("eloca:carteira-kanban-leitura-oportunidade", {
            detail: { oportunidadeId: Number(oportunidadeId) },
        }),
    );
}

export function novoEmailUpdateCarteiraKanban(body) {
    if (!isCarteiraKanbanPage() || !body || body.enviado) {
        return;
    }
    window.dispatchEvent(
        new CustomEvent("eloca:carteira-kanban-novo-email", {
            detail: { oportunidadeId: Number(body.oportunidade_id) },
        }),
    );
}

export function lidoEmailUpdateCarteiraKanban(body) {
    if (!isCarteiraKanbanPage() || !body) {
        return;
    }
    window.dispatchEvent(
        new CustomEvent("eloca:carteira-kanban-lido-email", {
            detail: {
                oportunidadeId: Number(body.oportunidade_id),
                naoLidos: parseInt(body.naoLidos, 10) || 0,
            },
        }),
    );
}

export function kanbanCarteiraUpdateFromSocket(body) {
    if (!isCarteiraKanbanPage() || !body || body.tipo !== "kanbanCarteira") {
        return;
    }
    if (body.acao === "clienteAtualizado" && body.cliente_pai_id) {
        window.dispatchEvent(
            new CustomEvent("eloca:carteira-kanban-cliente-atualizado", {
                detail: {
                    clientePaiId: Number(body.cliente_pai_id),
                    donoId:
                        body.dono_id != null && body.dono_id !== ""
                            ? Number(body.dono_id)
                            : null,
                    donoAnteriorId:
                        body.dono_anterior_id != null &&
                        body.dono_anterior_id !== ""
                            ? Number(body.dono_anterior_id)
                            : null,
                    faseId:
                        body.carteira_cliente_fase_id != null &&
                        body.carteira_cliente_fase_id !== ""
                            ? Number(body.carteira_cliente_fase_id)
                            : null,
                },
            }),
        );
        return;
    }
    if (body.acao === "carteiraDonosAtualizada" && Array.isArray(body.dono_ids)) {
        window.dispatchEvent(
            new CustomEvent("eloca:carteira-kanban-donos-atualizada", {
                detail: {
                    donoIds: body.dono_ids
                        .map((id) => Number(id))
                        .filter((id) => Number.isFinite(id) && id > 0),
                },
            }),
        );
    }
}

/**
 * Escapa a classe para uso em seletor (ex.: ids "wamid..." do WhatsApp Cloud
 * contêm "." e "==", que quebram o Sizzle/jQuery).
 */
function classeEscapada(valor) {
    if (isEmpty(valor)) {
        return "";
    }
    return CSS.escape(String(valor));
}

export function subirOportunidadeKanbanParaTopo(oportunidadeId, faseId) {
    const query = `.js-op-${oportunidadeId}`;
    const opEl = document.querySelector(query);
    if (opEl) {
        const topoLista = opEl.closest(".ui-state-default");
        if (topoLista) {
            $(topoLista).parent().prepend($(query));
        }
        if (
            $("#kanban").data("kanban-v2") &&
            typeof window.fluxoKanbanV2OrdenaOportunidades === "function"
        ) {
            window.fluxoKanbanV2OrdenaOportunidades(document);
        }
        return;
    }
    if ($("#kanban").data("kanban-v2") && faseId != null && faseId !== "") {
        atualizaCardOportunidadeKanbanNaFase(oportunidadeId, faseId);
    }
}

/**
 * Atualiza ordenação/badge/totais do kanban ao chegar mensagem.
 * skipBadge: dono com chat aberto (leitura em andamento) — só reordena.
 */
function atualizarKanbanPorNovaMensagem(oportunidadeId, faseId, options) {
    if (
        $("#kanban").length <= 0 &&
        $("#minhas-oportunidades").length <= 0
    ) {
        return;
    }
    const skipBadge = Boolean(options && options.skipBadge);
    if (skipBadge) {
        subirOportunidadeKanbanParaTopo(oportunidadeId, faseId);
        return;
    }
    novaMensagemUpdate(oportunidadeId, faseId);
}

function isDonoOportunidadeNoBody(body) {
    return (
        body &&
        body.user_id != null &&
        String(body.user_id) === String(window.userId ?? "")
    );
}

function elocaHubNotificationSocketOnMessage(context, event) {
    const dados = JSON.parse(event.data || "{}");
    const body = dados.body;
    const oportunidadeId = body.oportunidade_id;
    const configElocaHubId = body.configElocaHubId;
    if (dados.action == "conversaSync") {
        // Quando a mensagem também foi emitida via novaMensagem, o dono da
        // oportunidade já a recebe pelo socket principal; o conversaSync
        // só escreve no chat / atualiza kanban para quem não é dono.
        const donoJaRecebeuViaNovaMensagem =
            Boolean(body.enviadoViaNovaMensagem) &&
            isDonoOportunidadeNoBody(body);

        if (
            $(
                `.js-container-chat#oportunidade-${oportunidadeId}-${configElocaHubId}`,
                context
            ).length
        ) {
            let direcao = "in";
            if (body.mensagem && body.mensagem.direcao) {
                direcao = body.mensagem.direcao;
            }
            const contextChat = $(
                `.js-container-chat#oportunidade-${oportunidadeId}-${configElocaHubId}`
            ).closest(".oportunidade-chat");
            $(".js-aguardando-resposta", contextChat).remove();

            const gupshupId = body.gupshupId || body.mensagem?.gupshup_message_id;
            const mensagemJaNoChat =
                direcao === "out"
                && (
                    (body.mensagem?.id
                        && $(`#js-mensagem-${body.mensagem.id}`, contextChat).length)
                    || (gupshupId
                        && $(`.${classeEscapada(gupshupId)}`, contextChat).length)
                );

            if (mensagemJaNoChat) {
                let msgEl = body.mensagem?.id
                    ? $(`#js-mensagem-${body.mensagem.id}`, contextChat)
                    : $();
                if (!msgEl.length && gupshupId) {
                    msgEl = $(`.${classeEscapada(gupshupId)}`, contextChat).first();
                }
                if (gupshupId && msgEl.length) {
                    msgEl.addClass(gupshupId);
                }
            } else if (
                !donoJaRecebeuViaNovaMensagem
                && !(isDonoOportunidadeNoBody(body) && direcao === "out")
            ) {
                parseChatMessage(
                    contextChat,
                    body,
                    body.protocoloId,
                    direcao,
                );
            }
        }
        if (
            $("#kanban").length > 0 ||
            $("#minhas-oportunidades").length > 0
        ) {
            const direcao = body.mensagem?.direcao || "in";
            const chatAberto = $(
                `.js-container-chat#oportunidade-${oportunidadeId}-${configElocaHubId}`,
                context
            ).length;
            const msgId = body.mensagem?.id;
            const opEl = document.querySelector(`.js-op-${oportunidadeId}`);
            const jaContou =
                msgId != null &&
                opEl &&
                opEl.getAttribute("data-last-unread-msg-id") === String(msgId);

            if (direcao === "in" && !chatAberto && !jaContou) {
                if (msgId != null && opEl) {
                    opEl.setAttribute("data-last-unread-msg-id", String(msgId));
                }
                novaMensagemUpdate(oportunidadeId, body.fase_id);
            } else {
                subirOportunidadeKanbanParaTopo(oportunidadeId, body.fase_id);
            }
        }
        if ($("#react-app").length) {
            novaMensagemUpdateReact(oportunidadeId);
        }
    }
}

function elocaHubMainSocketOnMessage(
    context,
    box,
    rotaOportunidades,
    rotaOportunidadeShow,
    userPipelines,
    event,
) {
    const dados = JSON.parse(event.data || "{}");
    const body = dados.body;
    const oportunidadeId = body.oportunidade_id;
    const configElocaHubId = body.configElocaHubId;
    const oportunidadeNome = body.oportunidade_nome;

    let pipelineId = parseInt(body.pipeline_id);
    if (isNaN(pipelineId)) {
        pipelineId = 0;
    }

    $(".js-sem-notificacao", box).remove();
    if (
        dados.action == "novaOportunidade" &&
        userPipelines.includes(pipelineId)
    ) {
        const descricao =
            "Nova oportunidade criada via " + body.channel;

        $(".js-area-notificacoes", box).prepend(`
                        <a class="dropdown-item" href="${rotaOportunidades}">
                            <div class="d-flex align-items-center">
                                <div class="mr-3">
                                    <div class="icon-circle bg-success p-2">
                                        <i class="fab fa-whatsapp text-white"></i>
                                    </div>
                                </div>
                                <span>${descricao}</span>
                            </div>
                        </a>
                    `);
        showBrowserNotification(
            "Nova oportunidade",
            descricao,
            rotaOportunidades,
            body.icon
        );

        const kanbanPipeline = parseInt($("#kanban").data("pipeline"));
        const faseId = body.fase_id;

        // Coloca a oportunidade na barra lateral de oportunidade
        if ($("#minhas-oportunidades").length) {
            insereOportunidadeKanban(
                oportunidadeId,
                "minhas-oportunidades",
                faseId
            );
        }

        if ($("#kanban").length && kanbanPipeline == pipelineId) {
            insereOportunidadeKanban(oportunidadeId, "kanban", faseId);
        }

        if ($("#react-app").length) {
            enviaOportunidadeParaOReact(oportunidadeId);
        }
    } else if (dados.action == "novaMensagem") {
        if (
            $(
                `.js-container-chat#oportunidade-${oportunidadeId}-${configElocaHubId}`,
                context
            ).length
        ) {
            let direcao = "in";
            if (body.mensagem && body.mensagem.direcao) {
                direcao = body.mensagem.direcao;
            }
            const contextChat = $(
                `.js-container-chat#oportunidade-${oportunidadeId}-${configElocaHubId}`
            ).closest(".oportunidade-chat");
            $(".js-aguardando-resposta", contextChat).remove();

            parseChatMessage(
                contextChat,
                body,
                body.protocoloId,
                direcao,
            );
            atualizarKanbanPorNovaMensagem(oportunidadeId, body.fase_id, {
                skipBadge: isDonoOportunidadeNoBody(body),
            });
            if ($("#react-app").length) {
                novaMensagemUpdateReact(oportunidadeId);
            }
        } else {
            const rota = rotaOportunidadeShow.replace(
                "xxx",
                oportunidadeId
            );

            const areaNotifGlobal = document.querySelector(".js-area-notificacoes");
            const notiExistente = document.querySelector(
                ".noti-mensagem" + oportunidadeId,
            );
            var hasNotificacaoWebSocket = Boolean(
                areaNotifGlobal &&
                    notiExistente &&
                    areaNotifGlobal.contains(notiExistente),
            );
            if (!hasNotificacaoWebSocket) {
                $(".js-area-notificacoes", box).prepend(`
                            <a class="dropdown-item noti-mensagem ${oportunidadeId}" href="${rota}">
                                <div class="d-flex align-items-center">
                                    <div class="mr-3">
                                        <div class="icon-circle bg-primary p-2">
                                            <i class="fas fa-comment text-white"></i>
                                        </div>
                                    </div>
                                    <span>Nova(s) mensagem(gens) no Chat (Oportunidade ${oportunidadeId} - ${oportunidadeNome})</span>
                                </div>
                            </a>`);
            }

            let mensagem = "Mensagem recebida";
            if (
                body.mensagem.mensagem &&
                body.mensagem.mensagem.trim() !== ""
            ) {
                mensagem = body.mensagem.mensagem;
            } else if (
                body.mensagem &&
                body.mensagem.fileUrl &&
                body.mensagem.fileUrl.trim() !== ""
            ) {
                mensagem = "Arquivo recebido";
            }

            if (body.user_id) {
                showBrowserNotification(
                    body.cliente_nome + " via " + body.channel,
                    mensagem,
                    rota,
                    body.icon
                );
            }

            if (
                $("#kanban").length > 0 ||
                $("#minhas-oportunidades").length > 0
            ) {
                const msgId = body.mensagem?.id;
                const opEl = document.querySelector(`.js-op-${oportunidadeId}`);
                if (msgId != null && opEl) {
                    opEl.setAttribute("data-last-unread-msg-id", String(msgId));
                }
                novaMensagemUpdate(oportunidadeId, body.fase_id);
            }
            if ($("#react-app").length) {
                novaMensagemUpdateReact(oportunidadeId);
            }
            novaMensagemUpdateCarteiraKanban(oportunidadeId);
        }
    } else if (dados.action == "oportunidadeTransferida") {
        const rota = rotaOportunidadeShow.replace(
            "xxx",
            oportunidadeId
        );
        $(".js-area-notificacoes", box).prepend(`
                            <a class="dropdown-item" href="${rota}">
                                <div class="d-flex align-items-center">
                                    <div class="mr-3">
                                        <div class="icon-circle bg-primary p-2">
                                            <i class="fas fa-comment text-white"></i>
                                        </div>
                                    </div>
                                    <span>Uma oportunidade foi transferida para você</span>
                                </div>
                            </a>
                        `);
        showBrowserNotification(
            "Nova mensagem",
            "Uma oportunidade foi transferida para você",
            rota
        );
    } else if (dados.action == "novaNotificacao") {
        if (body.tipo == "reacao") {
            const gupshupMessageId = classeEscapada(body.gupshup_message_id);
            const gupshupRef = classeEscapada(body.gupshup_ref);
            if (gupshupMessageId && $(`.${gupshupMessageId}`, context).length) {
                if (body.reacao) {
                    $(`.${gupshupMessageId}`, context).addClass(
                        "com-reacao"
                    );
                    $(
                        `.${gupshupMessageId} .js-mensagem-reacao`,
                        context
                    ).removeClass("d-none");
                    $(
                        `.${gupshupMessageId} .js-mensagem-reacao .js-reacao-cliente`,
                        context
                    ).html(body.reacao);
                } else {
                    $(
                        `.${gupshupMessageId}`,
                        context
                    ).removeClass("com-reacao");
                    $(
                        `.${gupshupMessageId} .js-mensagem-reacao`,
                        context
                    ).addClass("d-none");
                    $(
                        `.${gupshupMessageId} .js-mensagem-reacao .js-reacao-cliente`,
                        context
                    ).html("");
                }
            } else if (gupshupRef && $(`.${gupshupRef}`, context).length) {
                if (body.reacao) {
                    $(`.${gupshupRef}`, context).addClass(
                        "com-reacao"
                    );
                    $(
                        `.${gupshupRef} .js-mensagem-reacao`,
                        context
                    ).removeClass("d-none");
                    $(
                        `.${gupshupRef} .js-mensagem-reacao .js-reacao-cliente`,
                        context
                    ).html(body.reacao);
                } else {
                    $(`.${gupshupRef}`, context).removeClass(
                        "com-reacao"
                    );
                    $(
                        `.${gupshupRef} .js-mensagem-reacao`,
                        context
                    ).addClass("d-none");
                    $(
                        `.${gupshupRef} .js-mensagem-reacao .js-reacao-cliente`,
                        context
                    ).html("");
                }
            }
        } else if (body.tipo == "leituraOportunidade") {
            if (String(body.user_id ?? "") === String(window.userId ?? "")) {
                // Remove itens do sino desta oportunidade para o badge decrementar no recalculo final.
                const rotaShowLeitura = rotaOportunidadeShow.replace(
                    "xxx",
                    oportunidadeId
                );
                $(
                    `.js-area-notificacoes a[href$="${rotaShowLeitura}"]`,
                    box
                ).remove();

                if (
                    $("#kanban").length > 0 ||
                    $("#minhas-oportunidades").length > 0
                ) {
                    limparContagemMensagensKanban(oportunidadeId);
                }
                if ($("#react-app").length) {
                    leituraOportunidadeUpdateReact(oportunidadeId);
                }
                leituraOportunidadeUpdateCarteiraKanban(oportunidadeId);
            }
        } else if (body.tipo == "kanbanOportunidade") {
            if (body.acao == "excluida") {
                removerOportunidadeCardsKanban(oportunidadeId);
                $(document).trigger("eloca:kanban-cards-changed");
                if ($("#react-app").length) {
                    kanbanOportunidadeUpdateReact(body);
                }
            } else if (body.acao == "transferida") {
                const kanbanPipeline = $("#kanban").length
                    ? parseInt($("#kanban").data("pipeline"), 10)
                    : NaN;
                const destPipeline = parseInt(body.pipeline_id, 10);
                const onKanban = $("#kanban").length > 0;
                const onMinhasSemKanban =
                    !onKanban && $("#minhas-oportunidades").length > 0;
                const hasPipelineAnterior =
                    body.pipeline_id_anterior != null &&
                    String(body.pipeline_id_anterior) !== "";
                if (hasPipelineAnterior) {
                    const sourcePipeline = parseInt(
                        body.pipeline_id_anterior,
                        10,
                    );
                    const isDestBoard =
                        onKanban &&
                        !Number.isNaN(kanbanPipeline) &&
                        !Number.isNaN(destPipeline) &&
                        kanbanPipeline === destPipeline;
                    const isSourceBoard =
                        onKanban &&
                        !Number.isNaN(kanbanPipeline) &&
                        !Number.isNaN(sourcePipeline) &&
                        kanbanPipeline === sourcePipeline;
                    if (isDestBoard && body.fase_id != null) {
                        atualizaCardOportunidadeKanbanNaFase(
                            oportunidadeId,
                            body.fase_id,
                        );
                    } else if (isSourceBoard) {
                        removerOportunidadeCardsKanban(oportunidadeId);
                        $(document).trigger("eloca:kanban-cards-changed");
                    } else if (onMinhasSemKanban) {
                        removerOportunidadeCardsKanban(oportunidadeId);
                        $(document).trigger("eloca:kanban-cards-changed");
                    }
                } else {
                    const mesmoPipeline =
                        !Number.isNaN(kanbanPipeline) &&
                        !Number.isNaN(destPipeline) &&
                        kanbanPipeline === destPipeline;
                    if (mesmoPipeline && body.fase_id != null) {
                        atualizaCardOportunidadeKanbanNaFase(
                            oportunidadeId,
                            body.fase_id,
                        );
                    } else {
                        removerOportunidadeCardsKanban(oportunidadeId);
                        $(document).trigger("eloca:kanban-cards-changed");
                    }
                }
                if ($("#react-app").length) {
                    kanbanOportunidadeUpdateReact(body);
                }
            } else if (body.acao == "faseAtualizada") {
                const kanbanPipeline = $("#kanban").length
                    ? parseInt($("#kanban").data("pipeline"), 10)
                    : NaN;
                const destPipeline = parseInt(body.pipeline_id, 10);
                const mesmoPipeline =
                    !Number.isNaN(kanbanPipeline) &&
                    !Number.isNaN(destPipeline) &&
                    kanbanPipeline === destPipeline;
                if (mesmoPipeline && body.fase_id != null) {
                    atualizaCardOportunidadeKanbanNaFase(
                        oportunidadeId,
                        body.fase_id,
                    );
                } else {
                    removerOportunidadeCardsKanban(oportunidadeId);
                    $(document).trigger("eloca:kanban-cards-changed");
                }
                if ($("#react-app").length) {
                    kanbanOportunidadeUpdateReact(body);
                }
            } else if (body.acao == "statusAtualizado") {
                const statusAberta = 1;
                const tipo = parseInt(body.status_tipo, 10);
                if (tipo === statusAberta) {
                    const kanbanPipeline = $("#kanban").length
                        ? parseInt($("#kanban").data("pipeline"), 10)
                        : NaN;
                    const destPipeline = parseInt(body.pipeline_id, 10);
                    const mesmoPipeline =
                        !Number.isNaN(kanbanPipeline) &&
                        !Number.isNaN(destPipeline) &&
                        kanbanPipeline === destPipeline;
                    if (mesmoPipeline && body.fase_id != null) {
                        atualizaCardOportunidadeKanbanNaFase(
                            oportunidadeId,
                            body.fase_id,
                        );
                    } else {
                        removerOportunidadeCardsKanban(oportunidadeId);
                        $(document).trigger("eloca:kanban-cards-changed");
                    }
                } else {
                    removerOportunidadeCardsKanban(oportunidadeId);
                    $(document).trigger("eloca:kanban-cards-changed");
                }
                if ($("#react-app").length) {
                    kanbanOportunidadeUpdateReact(body);
                }
            } else if (body.acao == "nomeAtualizado") {
                const nome =
                    typeof body.nome === "string" ? body.nome : "";
                    //alert(nome);
                    //alert(oportunidadeId);
                if (nome) {
                    $(`.js-op-${oportunidadeId}`)
                        .find(".nome")
                        .first()
                        .html(nome);
                }
                if ($("#react-app").length) {
                    kanbanOportunidadeUpdateReact(body);
                }
            } else if (body.acao == "orcamentoAtualizado") {
                const $kanban = $("#kanban");
                if ($kanban.length) {
                    const kanbanPipeline = parseInt(
                        $kanban.data("pipeline"),
                        10,
                    );
                    const destPipeline = parseInt(body.pipeline_id, 10);
                    const mesmoPipeline =
                        !Number.isNaN(kanbanPipeline) &&
                        !Number.isNaN(destPipeline) &&
                        kanbanPipeline === destPipeline;
                    if (mesmoPipeline) {
                        atualizaHtmlCardOportunidadeKanban(oportunidadeId);
                    }
                }
            }
        } else if (body.tipo == "whatsappCloudChamada") {
            if (window.WhatsAppCloudCalling) {
                window.WhatsAppCloudCalling.handleNotificacao(body);
            }
        } else if (body.tipo == "kanbanCarteira") {
            kanbanCarteiraUpdateFromSocket(body);
        } else if (body.tipo == "check") {
            const chatContainer = $(
                `.js-container-chat#oportunidade-${oportunidadeId}-${configElocaHubId}`,
                context
            );
            if (chatContainer.length) {
                const contextChat = chatContainer.closest(".oportunidade-chat");
                const gupshupMessageId = classeEscapada(
                    body.gupshup_message_id
                );
                if (body.message_status > 0) {
                    $(
                        `.${gupshupMessageId} .js-status-message`
                    ).addClass("d-none");
                    let statusText = "";
                    switch (body.message_status) {
                        case 1:
                            statusText = "enviada";
                            break;
                        case 2:
                            statusText = "entregue";
                            break;
                        case 3:
                            statusText = "lida";
                            break;
                        default:
                            statusText = "";
                    }
                    if (isEmpty(statusText) == false) {
                        $(
                            `.${gupshupMessageId}-${statusText}`
                        ).removeClass("d-none");
                    }

                    if (gupshupMessageId) {
                        const msgEl = $(`.${gupshupMessageId}`, contextChat);
                        if (msgEl.length) {
                            $(".js-aguardando-resposta", msgEl).remove();
                        } else {
                            $(".js-aguardando-resposta", contextChat).remove();
                        }
                    }
                }
            }
        } else {
            const titulo = body.tituloNotificacao;
            const descricao = body.descricaoNotificacao;
            const rota = rotaOportunidadeShow.replace(
                "xxx",
                oportunidadeId
            );
            $(".js-area-notificacoes", box).prepend(`
                            <a class="dropdown-item" href="${rota}">
                                <div class="d-flex align-items-center">
                                    <div class="mr-3">
                                        <div class="icon-circle bg-success p-2">
                                            <i class="fas fa-bell fa-fw"></i>
                                        </div>
                                    </div>
                                    <span>${descricao}</span>
                                </div>
                            </a>
                        `);
            showBrowserNotification(titulo, descricao, rota);
        }
    } else if (dados.action == "qrcode") {
        //qrcode
    } else if (dados.action == "retornarQrcode") {
        //retornarQrcode
    } else if (dados.action == "novoEmail") {
        const rota = rotaOportunidadeShow.replace(
            "xxx",
            oportunidadeId
        );

        const areaNotifGlobalEmail = document.querySelector(".js-area-notificacoes");
        const notiExistenteEmail = document.querySelector(
            ".noti-mensagem" + oportunidadeId,
        );
        var hasNotificacaoWebSocket = Boolean(
            areaNotifGlobalEmail &&
                notiExistenteEmail &&
                areaNotifGlobalEmail.contains(notiExistenteEmail),
        );
        if (!hasNotificacaoWebSocket && !body.enviado) {
            $(".js-area-notificacoes", box).prepend(`
                        <a class="dropdown-item noti-mensagem ${oportunidadeId}" href="${rota}">
                            <div class="d-flex align-items-center">
                                <div class="mr-3">
                                    <div class="icon-circle bg-primary p-2">
                                        <i class="fas fa-comment text-white"></i>
                                    </div>
                                </div>
                                <span>Novo(s) email(s) na Oportunidade ${oportunidadeId} - ${oportunidadeNome}</span>
                            </div>
                        </a>`);
        }

        let mensagem = "Email recebido";

        showBrowserNotification(
            "Novo email de " + body.from_name,
            mensagem,
            rota,
            body.icon
        );

        if (
            $("#kanban").length > 0 ||
            $("#minhas-oportunidades").length > 0
        ) {
            novoEmailUpdate(body);
        }
        novoEmailUpdateCarteiraKanban(body);
    } else if (dados.action == "lidoEmail") {
        if (
            $("#kanban").length > 0 ||
            $("#minhas-oportunidades").length > 0
        ) {
            lidoEmailUpdate(body);
        }
        lidoEmailUpdateCarteiraKanban(body);
    } else if (dados.action == "oportunidadeTransferidaExclude") {
        const opportunityToRemove = $(`.lista-oportunidades .js-op-${oportunidadeId}`);
        if (opportunityToRemove.length) {
            opportunityToRemove.closest('li').remove();
        }
    }

    const notificacoes = $(".js-area-notificacoes a", box).length;
    let restoNoti = 0;
    if ($("#resto-noti-js").length) {
        restoNoti = parseInt($("#resto-noti-js").text()) || 0;
    }
    const totalBadge = notificacoes + restoNoti;
    if (totalBadge > 0) {
        $(".js-badge-alert", box)
            .removeClass("d-none")
            .html(totalBadge);
    } else {
        $(".js-badge-alert", box).addClass("d-none").html("");
    }
}

/**
 * Eloca.load(document) roda no fim do bundle; em alguns hosts (preview da IDE,
 * extensões em document_start) document.body pode ainda não existir. O bridge
 * precisa de body para o iframe; adiar evita falha silenciosa do WebSocket.
 */
function scheduleElocaHubWebSocketInit(callback) {
    let started = false;
    const run = () => {
        if (!document.body || started) {
            return;
        }
        started = true;
        window.setTimeout(callback, 0);
    };

    if (document.body) {
        run();
    } else {
        document.addEventListener("DOMContentLoaded", run, { once: true });
        window.addEventListener("load", run, { once: true });
    }
}

export function conexaoWebSocketElocaHub(context) {
    scheduleElocaHubWebSocketInit(() => {
        const box = $(".js-eloca-hub-bell", context);
        const rotaOportunidades = $(box).data("rota-oportunidades");
        const rotaOportunidadeShow = $(box).data("rota-oportunidade-show");

        const userPipelines = JSON.parse(window.userPipelines);

        const useWsBridge =
            typeof window.elocaHubWsBridgeBaseUrl === "string" &&
            window.elocaHubWsBridgeBaseUrl.length > 0 &&
            typeof window.elocaHubBridgeToken === "string" &&
            window.elocaHubBridgeToken.length > 0;

        if (!useWsBridge) {
            window.__elocaHubWsBridgeReady = false;
        }

        if (useWsBridge) {
            if (!window.__elocaHubWsBridgeReady) {
                window.__elocaHubWsBridgeReady = true;
                const bridgeBase = window.elocaHubWsBridgeBaseUrl;
                const allowedOrigin = new URL(
                    bridgeBase.indexOf("?") >= 0
                        ? bridgeBase.split("?")[0]
                        : bridgeBase
                ).origin;
                const hasNotif =
                    $(".js-container-chat", context).length > 0 ||
                    $("#kanban").length > 0;
                const elocaHubBridgeMessageHandler = function (e) {
                    if (e.origin !== allowedOrigin) return;
                    if (!e.data || e.data.type !== "elocaHubWs") return;
                    const payload = e.data.payload;
                    if (e.data.channel === "main") {
                        elocaHubMainSocketOnMessage(
                            context,
                            box,
                            rotaOportunidades,
                            rotaOportunidadeShow,
                            userPipelines,
                            { data: payload }
                        );
                    } else if (e.data.channel === "notifications") {
                        elocaHubNotificationSocketOnMessage(context, {
                            data: payload,
                        });
                    }
                };
                window.__elocaHubWsBridgeMessageHandler =
                    elocaHubBridgeMessageHandler;
                window.addEventListener("message", elocaHubBridgeMessageHandler);
                const iframe = document.createElement("iframe");
                iframe.setAttribute("aria-hidden", "true");
                iframe.setAttribute("title", "");
                iframe.style.cssText =
                    "position:absolute;width:0;height:0;border:0;visibility:hidden";
                const notifParam = hasNotif ? "&notifications=1" : "";
                iframe.src =
                    bridgeBase +
                    (bridgeBase.indexOf("?") >= 0 ? "&" : "?") +
                    "token=" +
                    encodeURIComponent(window.elocaHubBridgeToken) +
                    "&parentOrigin=" +
                    encodeURIComponent(window.location.origin) +
                    notifParam;
                window.__elocaHubWsBridgeIframe = iframe;
                document.body.appendChild(iframe);
            }
            return;
        }

        try {
            const socket = new WebSocket(window.elocaHubWebSocketUrl);
            window.__elocaHubMainSocket = socket;

            if (
                $(".js-container-chat", context).length ||
                $("#kanban").length
            ) {
                const socketNotifications = new WebSocket(
                    window.elocaHubWebSocketUrlNotifications
                );
                window.__elocaHubNotificationSocket = socketNotifications;

                socketNotifications.onmessage = (event) => {
                    elocaHubNotificationSocketOnMessage(context, event);
                };
            }

            socket.onmessage = (event) => {
                elocaHubMainSocketOnMessage(
                    context,
                    box,
                    rotaOportunidades,
                    rotaOportunidadeShow,
                    userPipelines,
                    event,
                );
            };

        } catch (error) {
            if (error instanceof DOMException) {
                console.error("Ocorreu uma exceção DOMException:", error.message);
            } else {
                console.error("Ocorreu uma exceção:", error);
            }
        }
    });
}

export function encerrarConexaoWebSocketElocaHub() {
    if (window.__elocaHubMainSocket) {
        try {
            window.__elocaHubMainSocket.close();
        } catch (e) {
            /* ignore */
        }
        window.__elocaHubMainSocket = null;
    }
    if (window.__elocaHubNotificationSocket) {
        try {
            window.__elocaHubNotificationSocket.close();
        } catch (e) {
            /* ignore */
        }
        window.__elocaHubNotificationSocket = null;
    }
    if (window.__elocaHubWsBridgeMessageHandler) {
        window.removeEventListener(
            "message",
            window.__elocaHubWsBridgeMessageHandler,
        );
        window.__elocaHubWsBridgeMessageHandler = null;
    }
    if (window.__elocaHubWsBridgeIframe) {
        try {
            window.__elocaHubWsBridgeIframe.remove();
        } catch (e) {
            /* ignore */
        }
        window.__elocaHubWsBridgeIframe = null;
    }
    window.__elocaHubWsBridgeReady = false;
}

export function removerOportunidadeCardsKanban(oportunidadeId) {
    document
        .querySelectorAll(`li.js-op-${oportunidadeId}`)
        .forEach((li) => li.remove());
}

export function kanbanOportunidadeUpdateReact(body) {
    const iframeEl = document.getElementById("react-app");
    if (!iframeEl || !iframeEl.contentWindow) {
        return;
    }
    iframeEl.contentWindow.postMessage({ kanbanOportunidade: body }, "*");
}

/**
 * Limpa badge de mensagens não lidas, remove oportunidade-sem-dono e js-mensagem-nao-lida
 * (este último só se não restar email não lido no card).
 */
export function limparContagemMensagensKanban(oportunidadeId) {
    const query = `.js-op-${oportunidadeId}`;
    const opEl = document.querySelector(query);
    if (!opEl) {
        return;
    }

    $(opEl).find(".avisos .mensagem-nao-lida").remove();
    opEl.classList.remove("oportunidade-sem-dono");

    const aindaTemEmailNaoLido = $(opEl).find(".email-nao-lido").length > 0;
    if (!aindaTemEmailNaoLido) {
        opEl.classList.remove("js-mensagem-nao-lida");
    }

    $(document).trigger("eloca:kanban-cards-changed");
}

export function leituraOportunidadeUpdateReact(oportunidadeId) {
    const iframeEl = document.getElementById("react-app");
    if (!iframeEl || !iframeEl.contentWindow) {
        return;
    }
    iframeEl.contentWindow.postMessage(
        { leituraOportunidade: oportunidadeId },
        "*",
    );
}

export function novaMensagemUpdate(oportunidadeId, faseId) {
    const query = `.js-op-${oportunidadeId}`;

    const opEl = document.querySelector(query);
    if (!opEl) {
        subirOportunidadeKanbanParaTopo(oportunidadeId, faseId);
        return;
    }

    const now = new Date();
    const pad = (n) => String(n).padStart(2, "0");
    const horaIso = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
    // attr + data: o sort do kanban V2 usa $.data("hora"), que cacheia e ignora só setAttribute
    $(opEl).attr("data-hora", horaIso).data("hora", horaIso);
    opEl.classList.add("js-mensagem-nao-lida");

    if ($(`${query}`).find(".mensagem-nao-lida").text().length) {
        let span = $(query).find(".mensagem-nao-lida");
        let valorAtual = parseInt(span.text());
        let novoValor = valorAtual + 1;
        span.text(novoValor);
    } else {
        let data = new Date().toLocaleString("pt-BR", {
            timeZone: window.fusoHorario,
        });
        let horaAtual = data.split(" ")[1].slice(0, -3);

        let $avisos = $(`${query} .avisos`).first();
        if (!$avisos.length) {
            const $row = $(query).children("a").children("div").eq(1);
            if ($row.length) {
                $row.prepend('<div class="avisos float-right ml-1"></div>');
                $avisos = $(`${query} .avisos`).first();
            }
        }
        if ($avisos.length) {
            $avisos.html(
                `<span class="mensagem-nao-lida" title="Mensagens não lidas">1</span>`
            );
        }
        $(`${query} .dt`).html(`<span class="small">${horaAtual}</span>`);
    }

    // Marca o card como com mensagem nao lida (usado nos totais por fase do V1/V2).
    opEl.classList.add("js-mensagem-nao-lida");

    subirOportunidadeKanbanParaTopo(oportunidadeId, faseId);
    $(document).trigger("eloca:kanban-cards-changed");
}

export function novaMensagemUpdateReact(oportunidadeId) {
    const iframeEl = document.getElementById("react-app");
    if (!iframeEl || !iframeEl.contentWindow) {
        return;
    }
    const message = {
        novaMensagem: oportunidadeId,
    };

    iframeEl.contentWindow.postMessage(message, "*");
}

export function novoEmailUpdate(body) {
    let query = `.js-op-${body.oportunidade_id}`;

    if (body.enviado && ! $(`${query}`).find(".email-respondido-icon").length) {
        $(`${query}`)
            .find(".email-respondido")
            .append(
                '<i class="l-color fas fa-reply email-respondido-icon" title="Email respondido"></i>'
            );
    }
    if (! body.enviado) {
        $(`${query}`).find(".email-respondido-icon").remove();
        $(
            '<i class="email-unread-icon fa fa-envelope email-nao-lido" title="Email não lido"></i>'
        ).insertAfter($(`${query}`).find(".email-lido"));
        $(`${query}`).find(".email-lido").remove();
    }
}

export function lidoEmailUpdate(body) {
    let query = `.js-op-${body.oportunidade_id}`;

    if (body.naoLidos == 0) {
        $(
            '<i class="l-color far fa-envelope-open email-lido" title="Email lido"></i>'
        ).insertAfter($(`${query}`).find(".email-nao-lido"));
        $(`${query}`).find(".email-nao-lido").remove();
    } else {
        $(
            '<i class="email-unread-icon fa fa-envelope email-nao-lido" title="Email não lido"></i>'
        ).insertAfter($(`${query}`).find(".email-lido"));
        $(`${query}`).find(".email-lido").remove();
    }
}
